import React, { useState, useEffect } from 'react';

import { ContentBox } from '../../../Content/ContentBox';
import { SystemPromptInput } from '../../../Res/SystemPrompt';

export function GameEditInfo({ id, setIsLoading, isEdit, isAdd = false }) {


  var title = "賽事資料"
  var content =
    <>
      <div className="wrapper wrapper-content">
            
            
            
            <div className="tabs-container">
                <ul className="nav nav-tabs">
                    <li className="active"><a data-toggle="tab" href="#tab-1"> 客隊成績</a></li>
                    <li className=""><a data-toggle="tab" href="#tab-2">主隊成績</a></li>
                    <li className=""><a data-toggle="tab" href="#tab-3">客隊成績-官</a></li>
                    <li className=""><a data-toggle="tab" href="#tab-4">主隊成績-官</a></li>
                    <li className=""><a data-toggle="tab" href="#tab-5">Action List</a></li>
                </ul>
                <div className="tab-content">
                    <div id="tab-1" className="tab-pane active">
                        <div className="panel-body">

                            <div className="row">

                                <div className="col-md-12">
                                    <div className="col-md-2">
                                        <h3>打擊成績</h3>
                                    </div>

                                    <div className="col-md-2">
                                        <h3>主審：紀華文</h3>
                                    </div>

                                </div>
                            </div>


                            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <table className="table table-striped table-bordered table-hover  dataTable">
                                            <thead>
                                                <tr role="row">
                                                    <th className="text-left sorting col-sm-2">中信兄弟</th>
                                                    <th className="text-center sorting">AB</th>
                                                    <th className="text-center sorting">R</th>
                                                    <th className="text-center sorting">H</th>
                                                    <th className="text-center sorting">RBI</th>
                                                    <th className="text-center sorting">2B</th>
                                                    <th className="text-center sorting">3B</th>
                                                    <th className="text-center sorting">HR</th>
                                                    <th className="text-center sorting">GIDP</th>
                                                    <th className="text-center sorting">BB</th>
                                                    <th className="text-center sorting">HBP</th>
                                                    <th className="text-center sorting">SO</th>
                                                    <th className="text-center sorting">SAC</th>
                                                    <th className="text-center sorting">SF</th>
                                                    <th className="text-center sorting">SB</th>
                                                    <th className="text-center sorting">CS</th>
                                                    <th className="text-center sorting">E</th>
                                                    <th className="text-center sorting">AVG</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr role="row">
                                                    <td className="text-left">王威晨,3B</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>
                                                <tr role="row">
                                                    <td className="text-left">張志豪,RF</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>
                                                <tr role="row">
                                                    <td className="text-left"> ↑ 蘇緯達,(PH)</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>
                                                <tr role="row">
                                                    <td className="text-left"> ↑ 潘志芳,(RF)</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>
                                                <tr role="row">
                                                    <td className="text-left">周思齊,DH</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>
                                                <tr role="row">
                                                    <td className="text-left">許基宏,1B</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>
                                                <tr role="row">
                                                    <td className="text-left"> ↑ 張志強,(2B)</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>
                                                <tr role="row">
                                                    <td className="text-left">江坤宇,SS</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>
                                                <tr role="row">
                                                    <td className="text-left"> ↑ 杜家明,(PH) (1B)</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>
                                                <tr role="row">
                                                    <td className="text-left">詹子賢,LF</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>

                                                <tr role="row">
                                                    <td className="text-left"> ↑ 陳子豪,(LF)</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>

                                                <tr role="row">
                                                    <td className="text-left">岳東華,2B(SS))</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>

                                                <tr role="row">
                                                    <td className="text-left">陳家駒,C</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>

                                                <tr role="row">
                                                    <td className="text-left"> ↑ 高宇杰,(C)</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>

                                                <tr role="row">
                                                    <td className="text-left"> ↑ 林明杰,(PH)</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>

                                                <tr role="row">
                                                    <td className="text-left">岳政華,CF</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>

                                                <tr role="row">
                                                    <td className="text-left"> ↑ 林書逸,(PH)</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>


                                                <tr role="row">
                                                    <td className="text-left">Total</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>
                                                
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                
                            </div>

                            <div className="row">

                                <div className="col-md-12">
                                    <div className="col-md-2">
                                        <h3>投手成績</h3>
                                    </div>

                                    <div className="col-md-2">
                                        <h3>主審：紀華文</h3>
                                    </div>

                                </div>
                            </div>


                            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <table className="table table-striped table-bordered table-hover  dataTable">
                                            <thead>
                                                <tr role="row">
                                                    <th className="text-left sorting col-sm-2">中信兄弟</th>
                                                    <th className="text-center sorting">IP</th>
                                                    <th className="text-center sorting">BF</th>
                                                    <th className="text-center sorting">NP</th>
                                                    <th className="text-center sorting">S</th>
                                                    <th className="text-center sorting">H</th>
                                                    <th className="text-center sorting">HR</th>
                                                    <th className="text-center sorting">BB</th>
                                                    <th className="text-center sorting">HBP</th>
                                                    <th className="text-center sorting">SO</th>
                                                    <th className="text-center sorting">WP</th>
                                                    <th className="text-center sorting">BK</th>
                                                    <th className="text-center sorting">R</th>
                                                    <th className="text-center sorting">ER</th>
                                                    <th className="text-center sorting">ERA</th>
                                                    <th className="text-center sorting">WHIP</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr role="row">
                                                    <td className="text-left">德保拉(L,1-1)</td>
                                                    <td className="text-center">7.0</td>
                                                    <td className="text-center">31</td>
                                                    <td className="text-center">116</td>
                                                    <td className="text-center">77</td>
                                                    <td className="text-center">8</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">6</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">5</td>
                                                    <td className="text-center">5</td>
                                                    <td className="text-center">3.60</td>
                                                    <td className="text-center">1.07</td>
                                                    
                                                </tr>
                                                <tr role="row">
                                                    <td className="text-left">吳俊偉</td>
                                                    <td className="text-center">0.1</td>
                                                    <td className="text-center">3</td>
                                                    <td className="text-center">6</td>
                                                    <td className="text-center">5</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">6.75</td>
                                                    <td className="text-center">1.88</td>
                                                    
                                                </tr>
                                                
                                                
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                
                            </div>


                        </div>

                    </div>


                    <div id="tab-2" className="tab-pane">
                        <div className="panel-body">
                             

                                <div className="row">

                                    <div className="col-md-12">
                                        <div className="col-md-2">
                                            <h3>打擊成績</h3>
                                        </div>

                                        <div className="col-md-2">
                                            <h3>主審：紀華文</h3>
                                        </div>

                                    </div>
                                </div>


                                <div id="editable_wrapper" className="form-inline dt-bootstrap">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <table className="table table-striped table-bordered table-hover  dataTable">
                                                <thead>
                                                    <tr role="row">
                                                        <th className="text-left sorting col-sm-2">富邦悍將</th>
                                                        <th className="text-center sorting">AB</th>
                                                        <th className="text-center sorting">R</th>
                                                        <th className="text-center sorting">H</th>
                                                        <th className="text-center sorting">RBI</th>
                                                        <th className="text-center sorting">2B</th>
                                                        <th className="text-center sorting">3B</th>
                                                        <th className="text-center sorting">HR</th>
                                                        <th className="text-center sorting">GIDP</th>
                                                        <th className="text-center sorting">BB</th>
                                                        <th className="text-center sorting">HBP</th>
                                                        <th className="text-center sorting">SO</th>
                                                        <th className="text-center sorting">SAC</th>
                                                        <th className="text-center sorting">SF</th>
                                                        <th className="text-center sorting">SB</th>
                                                        <th className="text-center sorting">CS</th>
                                                        <th className="text-center sorting">E</th>
                                                        <th className="text-center sorting">AVG</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr role="row">
                                                        <td className="text-left">王威晨,3B</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>
                                                    <tr role="row">
                                                        <td className="text-left">張志豪,RF</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>
                                                    <tr role="row">
                                                        <td className="text-left"> ↑ 蘇緯達,(PH)</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>
                                                    <tr role="row">
                                                        <td className="text-left"> ↑ 潘志芳,(RF)</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>
                                                    <tr role="row">
                                                        <td className="text-left">周思齊,DH</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>
                                                    <tr role="row">
                                                        <td className="text-left">許基宏,1B</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>
                                                    <tr role="row">
                                                        <td className="text-left"> ↑ 張志強,(2B)</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>
                                                    <tr role="row">
                                                        <td className="text-left">江坤宇,SS</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>
                                                    <tr role="row">
                                                        <td className="text-left"> ↑ 杜家明,(PH) (1B)</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>
                                                    <tr role="row">
                                                        <td className="text-left">詹子賢,LF</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>

                                                    <tr role="row">
                                                        <td className="text-left"> ↑ 陳子豪,(LF)</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>

                                                    <tr role="row">
                                                        <td className="text-left">岳東華,2B(SS))</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>

                                                    <tr role="row">
                                                        <td className="text-left">陳家駒,C</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>

                                                    <tr role="row">
                                                        <td className="text-left"> ↑ 高宇杰,(C)</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>

                                                    <tr role="row">
                                                        <td className="text-left"> ↑ 林明杰,(PH)</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>

                                                    <tr role="row">
                                                        <td className="text-left">岳政華,CF</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>

                                                    <tr role="row">
                                                        <td className="text-left"> ↑ 林書逸,(PH)</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>


                                                    <tr role="row">
                                                        <td className="text-left">Total</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>
                                                    
                                                    
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    
                                </div>

                                <div className="row">

                                    <div className="col-md-12">
                                        <div className="col-md-2">
                                            <h3>投手成績</h3>
                                        </div>

                                        <div className="col-md-2">
                                            <h3>主審：紀華文</h3>
                                        </div>

                                    </div>
                                </div>


                                <div id="editable_wrapper" className="form-inline dt-bootstrap">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <table className="table table-striped table-bordered table-hover  dataTable">
                                                <thead>
                                                    <tr role="row">
                                                        <th className="text-left sorting col-sm-2">富邦悍將</th>
                                                        <th className="text-center sorting">IP</th>
                                                        <th className="text-center sorting">BF</th>
                                                        <th className="text-center sorting">NP</th>
                                                        <th className="text-center sorting">S</th>
                                                        <th className="text-center sorting">H</th>
                                                        <th className="text-center sorting">HR</th>
                                                        <th className="text-center sorting">BB</th>
                                                        <th className="text-center sorting">HBP</th>
                                                        <th className="text-center sorting">SO</th>
                                                        <th className="text-center sorting">WP</th>
                                                        <th className="text-center sorting">BK</th>
                                                        <th className="text-center sorting">R</th>
                                                        <th className="text-center sorting">ER</th>
                                                        <th className="text-center sorting">ERA</th>
                                                        <th className="text-center sorting">WHIP</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr role="row">
                                                        <td className="text-left">德保拉(L,1-1)</td>
                                                        <td className="text-center">7.0</td>
                                                        <td className="text-center">31</td>
                                                        <td className="text-center">116</td>
                                                        <td className="text-center">77</td>
                                                        <td className="text-center">8</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">6</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">5</td>
                                                        <td className="text-center">5</td>
                                                        <td className="text-center">3.60</td>
                                                        <td className="text-center">1.07</td>
                                                        
                                                    </tr>
                                                    <tr role="row">
                                                        <td className="text-left">吳俊偉</td>
                                                        <td className="text-center">0.1</td>
                                                        <td className="text-center">3</td>
                                                        <td className="text-center">6</td>
                                                        <td className="text-center">5</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">6.75</td>
                                                        <td className="text-center">1.88</td>
                                                        
                                                    </tr>
                                                    
                                                    
                                                    
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    
                                </div>


                        </div>
                    
                    </div>


                    <div id="tab-3" className="tab-pane">
                        <div className="panel-body">

                            <div className="row">

                                <div className="col-md-12">
                                    <div className="col-md-2">
                                        <h3>打擊成績-官</h3>
                                    </div>

                                    <div className="col-md-2">
                                        <h3>主審：紀華文</h3>
                                    </div>

                                </div>
                            </div>


                            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <table className="table table-striped table-bordered table-hover  dataTable">
                                            <thead>
                                                <tr role="row">
                                                    <th className="text-left sorting col-sm-2">中信兄弟</th>
                                                    <th className="text-center sorting">AB</th>
                                                    <th className="text-center sorting">R</th>
                                                    <th className="text-center sorting">H</th>
                                                    <th className="text-center sorting">RBI</th>
                                                    <th className="text-center sorting">2B</th>
                                                    <th className="text-center sorting">3B</th>
                                                    <th className="text-center sorting">HR</th>
                                                    <th className="text-center sorting">GIDP</th>
                                                    <th className="text-center sorting">BB</th>
                                                    <th className="text-center sorting">HBP</th>
                                                    <th className="text-center sorting">SO</th>
                                                    <th className="text-center sorting">SAC</th>
                                                    <th className="text-center sorting">SF</th>
                                                    <th className="text-center sorting">SB</th>
                                                    <th className="text-center sorting">CS</th>
                                                    <th className="text-center sorting">E</th>
                                                    <th className="text-center sorting">AVG</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr role="row">
                                                    <td className="text-left">王威晨,3B</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>
                                                <tr role="row">
                                                    <td className="text-left">張志豪,RF</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>
                                                <tr role="row">
                                                    <td className="text-left"> ↑ 蘇緯達,(PH)</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>
                                                <tr role="row">
                                                    <td className="text-left"> ↑ 潘志芳,(RF)</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>
                                                <tr role="row">
                                                    <td className="text-left">周思齊,DH</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>
                                                <tr role="row">
                                                    <td className="text-left">許基宏,1B</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>
                                                <tr role="row">
                                                    <td className="text-left"> ↑ 張志強,(2B)</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>
                                                <tr role="row">
                                                    <td className="text-left">江坤宇,SS</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>
                                                <tr role="row">
                                                    <td className="text-left"> ↑ 杜家明,(PH) (1B)</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>
                                                <tr role="row">
                                                    <td className="text-left">詹子賢,LF</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>

                                                <tr role="row">
                                                    <td className="text-left"> ↑ 陳子豪,(LF)</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>

                                                <tr role="row">
                                                    <td className="text-left">岳東華,2B(SS))</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>

                                                <tr role="row">
                                                    <td className="text-left">陳家駒,C</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>

                                                <tr role="row">
                                                    <td className="text-left"> ↑ 高宇杰,(C)</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>

                                                <tr role="row">
                                                    <td className="text-left"> ↑ 林明杰,(PH)</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>

                                                <tr role="row">
                                                    <td className="text-left">岳政華,CF</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>

                                                <tr role="row">
                                                    <td className="text-left"> ↑ 林書逸,(PH)</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>


                                                <tr role="row">
                                                    <td className="text-left">Total</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0.36</td>
                                                    
                                                </tr>
                                                
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                
                            </div>

                            <div className="row">

                                <div className="col-md-12">
                                    <div className="col-md-2">
                                        <h3>投手成績-官</h3>
                                    </div>

                                    <div className="col-md-2">
                                        <h3>主審：紀華文</h3>
                                    </div>

                                </div>
                            </div>


                            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <table className="table table-striped table-bordered table-hover  dataTable">
                                            <thead>
                                                <tr role="row">
                                                    <th className="text-left sorting col-sm-2">中信兄弟</th>
                                                    <th className="text-center sorting">IP</th>
                                                    <th className="text-center sorting">BF</th>
                                                    <th className="text-center sorting">NP</th>
                                                    <th className="text-center sorting">S</th>
                                                    <th className="text-center sorting">H</th>
                                                    <th className="text-center sorting">HR</th>
                                                    <th className="text-center sorting">BB</th>
                                                    <th className="text-center sorting">HBP</th>
                                                    <th className="text-center sorting">SO</th>
                                                    <th className="text-center sorting">WP</th>
                                                    <th className="text-center sorting">BK</th>
                                                    <th className="text-center sorting">R</th>
                                                    <th className="text-center sorting">ER</th>
                                                    <th className="text-center sorting">ERA</th>
                                                    <th className="text-center sorting">WHIP</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr role="row">
                                                    <td className="text-left">德保拉(L,1-1)</td>
                                                    <td className="text-center">7.0</td>
                                                    <td className="text-center">31</td>
                                                    <td className="text-center">116</td>
                                                    <td className="text-center">77</td>
                                                    <td className="text-center">8</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">6</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">1</td>
                                                    <td className="text-center">5</td>
                                                    <td className="text-center">5</td>
                                                    <td className="text-center">3.60</td>
                                                    <td className="text-center">1.07</td>
                                                    
                                                </tr>
                                                <tr role="row">
                                                    <td className="text-left">吳俊偉</td>
                                                    <td className="text-center">0.1</td>
                                                    <td className="text-center">3</td>
                                                    <td className="text-center">6</td>
                                                    <td className="text-center">5</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">0</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">2</td>
                                                    <td className="text-center">6.75</td>
                                                    <td className="text-center">1.88</td>
                                                    
                                                </tr>
                                                
                                                
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                
                            </div>


                        </div>

                    </div>


                    <div id="tab-4" className="tab-pane">
                        <div className="panel-body">
                             

                                <div className="row">

                                    <div className="col-md-12">
                                        <div className="col-md-2">
                                            <h3>打擊成績-官</h3>
                                        </div>

                                        <div className="col-md-2">
                                            <h3>主審：紀華文</h3>
                                        </div>

                                    </div>
                                </div>


                                <div id="editable_wrapper" className="form-inline dt-bootstrap">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <table className="table table-striped table-bordered table-hover  dataTable">
                                                <thead>
                                                    <tr role="row">
                                                        <th className="text-left sorting col-sm-2">富邦悍將</th>
                                                        <th className="text-center sorting">AB</th>
                                                        <th className="text-center sorting">R</th>
                                                        <th className="text-center sorting">H</th>
                                                        <th className="text-center sorting">RBI</th>
                                                        <th className="text-center sorting">2B</th>
                                                        <th className="text-center sorting">3B</th>
                                                        <th className="text-center sorting">HR</th>
                                                        <th className="text-center sorting">GIDP</th>
                                                        <th className="text-center sorting">BB</th>
                                                        <th className="text-center sorting">HBP</th>
                                                        <th className="text-center sorting">SO</th>
                                                        <th className="text-center sorting">SAC</th>
                                                        <th className="text-center sorting">SF</th>
                                                        <th className="text-center sorting">SB</th>
                                                        <th className="text-center sorting">CS</th>
                                                        <th className="text-center sorting">E</th>
                                                        <th className="text-center sorting">AVG</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr role="row">
                                                        <td className="text-left">王威晨,3B</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>
                                                    <tr role="row">
                                                        <td className="text-left">張志豪,RF</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>
                                                    <tr role="row">
                                                        <td className="text-left"> ↑ 蘇緯達,(PH)</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>
                                                    <tr role="row">
                                                        <td className="text-left"> ↑ 潘志芳,(RF)</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>
                                                    <tr role="row">
                                                        <td className="text-left">周思齊,DH</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>
                                                    <tr role="row">
                                                        <td className="text-left">許基宏,1B</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>
                                                    <tr role="row">
                                                        <td className="text-left"> ↑ 張志強,(2B)</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>
                                                    <tr role="row">
                                                        <td className="text-left">江坤宇,SS</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>
                                                    <tr role="row">
                                                        <td className="text-left"> ↑ 杜家明,(PH) (1B)</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>
                                                    <tr role="row">
                                                        <td className="text-left">詹子賢,LF</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>

                                                    <tr role="row">
                                                        <td className="text-left"> ↑ 陳子豪,(LF)</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>

                                                    <tr role="row">
                                                        <td className="text-left">岳東華,2B(SS))</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>

                                                    <tr role="row">
                                                        <td className="text-left">陳家駒,C</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>

                                                    <tr role="row">
                                                        <td className="text-left"> ↑ 高宇杰,(C)</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>

                                                    <tr role="row">
                                                        <td className="text-left"> ↑ 林明杰,(PH)</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>

                                                    <tr role="row">
                                                        <td className="text-left">岳政華,CF</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>

                                                    <tr role="row">
                                                        <td className="text-left"> ↑ 林書逸,(PH)</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>


                                                    <tr role="row">
                                                        <td className="text-left">Total</td>
                                                        <td className="text-center">4</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0.36</td>
                                                        
                                                    </tr>
                                                    
                                                    
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    
                                </div>

                                <div className="row">

                                    <div className="col-md-12">
                                        <div className="col-md-2">
                                            <h3>投手成績-官</h3>
                                        </div>

                                        <div className="col-md-2">
                                            <h3>主審：紀華文</h3>
                                        </div>

                                    </div>
                                </div>


                                <div id="editable_wrapper" className="form-inline dt-bootstrap">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <table className="table table-striped table-bordered table-hover  dataTable">
                                                <thead>
                                                    <tr role="row">
                                                        <th className="text-left sorting col-sm-2">富邦悍將</th>
                                                        <th className="text-center sorting">IP</th>
                                                        <th className="text-center sorting">BF</th>
                                                        <th className="text-center sorting">NP</th>
                                                        <th className="text-center sorting">S</th>
                                                        <th className="text-center sorting">H</th>
                                                        <th className="text-center sorting">HR</th>
                                                        <th className="text-center sorting">BB</th>
                                                        <th className="text-center sorting">HBP</th>
                                                        <th className="text-center sorting">SO</th>
                                                        <th className="text-center sorting">WP</th>
                                                        <th className="text-center sorting">BK</th>
                                                        <th className="text-center sorting">R</th>
                                                        <th className="text-center sorting">ER</th>
                                                        <th className="text-center sorting">ERA</th>
                                                        <th className="text-center sorting">WHIP</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr role="row">
                                                        <td className="text-left">德保拉(L,1-1)</td>
                                                        <td className="text-center">7.0</td>
                                                        <td className="text-center">31</td>
                                                        <td className="text-center">116</td>
                                                        <td className="text-center">77</td>
                                                        <td className="text-center">8</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">6</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">1</td>
                                                        <td className="text-center">5</td>
                                                        <td className="text-center">5</td>
                                                        <td className="text-center">3.60</td>
                                                        <td className="text-center">1.07</td>
                                                        
                                                    </tr>
                                                    <tr role="row">
                                                        <td className="text-left">吳俊偉</td>
                                                        <td className="text-center">0.1</td>
                                                        <td className="text-center">3</td>
                                                        <td className="text-center">6</td>
                                                        <td className="text-center">5</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">0</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">2</td>
                                                        <td className="text-center">6.75</td>
                                                        <td className="text-center">1.88</td>
                                                        
                                                    </tr>
                                                    
                                                    
                                                    
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    
                                </div>


                        </div>
                    
                    </div>

                    <div id="tab-5" className="tab-pane">
                        <div className="panel-body">
                            第五的內容
                        </div>
                    </div>
                </div>


            </div>

            
                

                <div className="row">
                    <div className="col-lg-12">
                        <div>
                            <p></p>
                        </div>
                    </div>
                </div>

                

                

                <div className="hr-line-dashed"></div>


            

            <p>&nbsp;</p>

            


            <p>&nbsp;</p>

        

        
        <div className="row text-right ">
            <div className="col-sm-12">
                <button className="btn btn-white" type="button"><i className="fa fa-times"></i>&nbsp;取消</button>
                <button className="btn btn-primary" type="button"><i className="fa fa-floppy-o"></i>&nbsp;儲存</button>   
            </div>
        </div>
    </div>
    </>


  return (
    <>
      <ContentBox title={title} titleSize={6} content={content} hasDrawer={false} />
    </>
  )
}